// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"VideoWrapper__Wrapper_3NBNF","Background":"VideoWrapper__Background_RN6dv"};